import React from 'react'

import { ButtonProps } from '../Button/Button'
import { StyledSocialButton } from './styledSocialButton'

export type SocialButtonProps = Omit<ButtonProps, 'color' | 'variant'> & {
  //
}

export const SocialButton: React.FC<SocialButtonProps> = (buttonProps) => (
  <StyledSocialButton outline {...buttonProps} />
)
